export default class ShiftCompletionSummaryDto {
    quantity: number;
    booked: number;
    bookedUnconfirmed: number;
    bookedConfirmed: number;
    bookedPercentage: number;
    bookingDateId: string;
}